<script setup lang="ts">
  import { MpCard, MpText, useMpScreen } from '@borg/ui';

  const { t } = useI18n();
  const { isMobile } = useMpScreen();
  const job = jobRepository.use();
</script>

<template>
  <MpCard
    v-if="job"
    :p="isMobile ? 'md' : 'lg'"
    shadow
    border
  >
    <Section>
      <SectionRow
        v-if="job.startsAt"
        :label="$t('JOB_DETAILS_PAGE.PUBLISHED_AT_LABEL')"
        :value="$d(...localeDateTimeFormat(job.startsAt, 'dmy'))"
      />
      <!-- TODO : Remove v-else-if case below after a while, after all jobs migrated with startsAt -->
      <SectionRow
        v-else-if="job.publishedAt"
        :label="$t('JOB_DETAILS_PAGE.PUBLISHED_AT_LABEL')"
        :value="$d(...localeDateTimeFormat(job.publishedAt, 'dmy'))"
      />
      <SectionRow
        v-if="job.additionalPositions?.length"
        :label="$t('JOB_DETAILS_PAGE.CATEGORIES_SECTION_TITLE')"
      >
        <div class="list">
          <LinksLocale
            v-for="position in job.additionalPositions"
            :key="position.id"
            :to="{ name: 'search', query: { positions: position.id } }"
            class="list__item"
          >
            <MpText link>
              {{ position.name }}
            </MpText>
          </LinksLocale>
        </div>
      </SectionRow>
      <SectionRow :label="$t('JOB_DETAILS_PAGE.WORK_MODE_SECTION_TITLE')">
        {{ getWorkTypeLocationString(job.workTypes ?? [], '', t, true) }}
      </SectionRow>
    </Section>
  </MpCard>
</template>

<style scoped lang="scss">
  .list {
    display: flex;
    flex-direction: column;
    gap: var(--mp-space-30);

    &__item {
      width: fit-content;
    }
  }
</style>
